import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useThemeStore } from './stores/themeStore';
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { ProductsPage } from './pages/ProductsPage';
import { LicensesPage } from './pages/LicensesPage';
import { ServersPage } from './pages/ServersPage';
import { CustomersPage } from './pages/CustomersPage';
import { LogsPage } from './pages/LogsPage';
import { Layout } from './components/Layout';

function App() {
    const { darkMode } = useThemeStore();

    const theme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: {
                main: '#3b82f6',
            },
            secondary: {
                main: '#64748b',
            },
        },
        typography: {
            fontFamily: 'Inter, system-ui, sans-serif',
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/" element={<Layout />}>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="products" element={<ProductsPage />} />
                    <Route path="licenses" element={<LicensesPage />} />
                    <Route path="servers" element={<ServersPage />} />
                    <Route path="customers" element={<CustomersPage />} />
                    <Route path="logs" element={<LogsPage />} />
                </Route>
            </Routes>
        </ThemeProvider>
    );
}

export default App;